// Aktiv verkaufte Dienstleistungen. Diese Liste speist JEDEN Auswahl-Select.
export const SERVICE_TYPE_OPTIONS = [
  { value: "real_estate_sale", label: "Real Estate Sale" },
  { value: "real_estate_brokerage", label: "Real Estate Brokerage" },
  { value: "real_estate_management", label: "Real Estate Management" },
  { value: "insertion_order", label: "Insertion Order" },
] as const;

export type ServiceType = (typeof SERVICE_TYPE_OPTIONS)[number]["value"];

// Nicht mehr verkaufte Dienstleistungen. Bewusst NICHT geloescht: 30 Zeilen in
// property_state_history tragen diese Werte noch (Stand 2026-09-20), und
// abgeschlossene Deals muessen in Dashboard, XLSX-Export und Digest weiterhin
// ihr deutsches Label zeigen statt des Rohwerts.
// Sie erscheinen in keinem Select - das tut nur SERVICE_TYPE_OPTIONS.
export const LEGACY_SERVICE_TYPES = [
  "final_cleaning",
  "house_maintenance",
  "gardening",
  "move",
  "electrical_service",
  "regular_cleaning",
  "floor_laying",
  "painting_work",
] as const;

export type LegacyServiceType = (typeof LEGACY_SERVICE_TYPES)[number];

// Jeder Wert, der in Bestandsdaten vorkommen kann - aktiv oder historisch.
// Label-Lookups typisieren gegen diesen Typ, Eingaben gegen ServiceType.
export type AnyServiceType = ServiceType | LegacyServiceType;

export const REAL_ESTATE_SERVICE_TYPES = [
  { value: "real_estate_sale", label: "Real Estate Sale" },
  { value: "real_estate_brokerage", label: "Real Estate Brokerage" },
  { value: "real_estate_management", label: "Real Estate Management" },
] as const;

export const ALL_REAL_ESTATE_SERVICE_TYPE_VALUES = REAL_ESTATE_SERVICE_TYPES.map(s => s.value);

// Nach der Katalogreduktion bleibt hier genau ein Wert. Die Zweiteilung ist
// trotzdem keine Kosmetik: backend/app/schemas/employee_goal.py validiert
// APPOINTMENTS gegen die Immobilien-Gruppe und SEND_OFFERS gegen diese hier.
// Eine flache Liste wuerde erlauben, ein Termin-Ziel auf insertion_order
// anzulegen oder ein Offerten-Ziel auf real_estate_sale.
export const NON_REAL_ESTATE_SERVICE_TYPES = [
  { value: "insertion_order", label: "Insertion Order" },
] as const;

export const ALL_NON_REAL_ESTATE_SERVICE_TYPE_VALUES = NON_REAL_ESTATE_SERVICE_TYPES.map(s => s.value);

export const EMPLOYEE_FUNCTION_OPTIONS = [
  { value: "sales_representative", label: "Sales Representative" },
  { value: "real_estate_agent", label: "Real Estate Agent" },
  { value: "facility_manager", label: "Facility Manager" },
] as const;

export const DEPARTMENT_OPTIONS = [
  { value: "management", label: "Management" },
  { value: "sales", label: "Sales" },
  { value: "it", label: "IT" },
  { value: "facilities", label: "Facilities" },
  { value: "estate", label: "Estate" },
  { value: "finance", label: "Finance" },
  { value: "assistance", label: "Assistance" },
] as const;

// Deckt aktive UND historische Werte ab. Die acht Legacy-Eintraege bleiben,
// damit Bestandsdaten ihr Label behalten - siehe LEGACY_SERVICE_TYPES.
export const SERVICE_TYPE_LABELS_DE: Record<AnyServiceType, string> = {
  real_estate_sale: "Immobilienverkauf",
  real_estate_brokerage: "Immobilienvermittlung",
  real_estate_management: "Immobilienverwaltung",
  insertion_order: "Inserateauftrag",
  final_cleaning: "Endreinigung",
  house_maintenance: "Hauswartung",
  gardening: "Gartenarbeit",
  move: "Umzug",
  electrical_service: "Elektroservice",
  regular_cleaning: "Regelmässige Reinigung",
  floor_laying: "Bodenlegen",
  painting_work: "Malerarbeit",
};
